export class ValidationError {
    constructor(obj) {
        this.length = obj._validateNested(this.nested = {});
        if (this.error = obj.validate(obj)) {
            this.length++;
        }
    }
    each(iteratee) {
        const { error, nested } = this;
        if (error)
            iteratee(error, null);
        for (const key in nested) {
            iteratee(nested[key], key);
        }
    }
    eachError(iteratee, object) {
        this.each((value, key) => {
            if (value instanceof ValidationError) {
                value.eachError(iteratee, object.get(key));
            }
            else {
                iteratee(value, key, object);
            }
        });
    }
}
//# sourceMappingURL=validation.js.map